export default {
    points: [
        { x: 3, y: 664510 },
        { x: 4, y: 620840 },
        { x: 5, y: 654790 },
        { x: 6, y: 714050 },
        { x: 7, y: 715580 },
        { x: 8, y: 694620 },
    ],
    yTicks: [0, 100000, 200000, 300000, 400000, 500000, 600000, 700000, 800000]
}